import { HStack, Icon, Link as ChakraLink, Stack } from "@chakra-ui/react";
import { MdArrowOutward } from "react-icons/md";
import Image from "next/image";
import { I18nLink } from "../i18n/I18nLink";
import Wrapper from "./Wrapper";
import { useTranslations } from "next-intl";

export default function Footer() {
  const t = useTranslations()

  return (
    // Футер
    <Wrapper py="40px" asChild>
      <Stack
        gap="20px"
        w={"100%"}
        borderTop={"1px solid #CDCDCD"}
        bg="white"
      >
        <ChakraLink
          as={I18nLink}
          href="/"
        >
          <Image
            src="/logo.svg"
            alt="QREP Logo"
            width={40}
            height={40}
            priority
            style={{ width: "auto", height: "auto" }}
          />
        </ChakraLink>
        <Stack gap="2px">
          {[
            { href: "/shop", label: t('catalog') },
            { href: "/faq", label: t('faq') },
            { href: "/about", label: t('about_us') },
            { href: "/contacts", label: t('contacts') },
            { href: "/career", label: t('careers') },
            { href: "/privacy", label: t('privacy_policy') },
            { href: "/offer", label: t('public_offer') },
            // { href: "/size-guide", label: t('sizes') },
            { href: "/shipping", label: t('ship') },
            { href: "/return", label: t('return') },
          ].map((item, idx) => (
            <ChakraLink key={idx} asChild textStyle={"regular16"}>
              <I18nLink href={item.href} prefetch={true}>{item.label}</I18nLink>
            </ChakraLink>
          ))}
        </Stack>
         <HStack alignItems={"start"}>
          <ChakraLink asChild textStyle={"bold16"} style={{ textTransform: "uppercase" }}>
            <I18nLink href="/corporate">{t('for_corporate_clients')}</I18nLink>
          </ChakraLink>
          <Icon size={"sm"}><MdArrowOutward/></Icon>
        </HStack> 
        <ChakraLink asChild textStyle={"regular16"}>
          <I18nLink href="/copyright">© 2026 All Rights Reserved</I18nLink>
        </ChakraLink>
      </Stack>
    </Wrapper>
  )
};